import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { slideInAnimation } from './core/models/animations';
import { MatDialog } from '@angular/material/dialog';
import { AdminService } from './core/services/admin-apis/admin.service';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    slideInAnimation
  ]
})
export class AppComponent implements OnInit{
  title = 'creatics-ui';
  currentTimezone :any
  dbTimezone: any; // last user timezone stored in database
  @ViewChild('dialogTemplate') dialogTemplate: TemplateRef<any>;

  constructor(  private service: AdminService,
    private dialog: MatDialog, private router: Router){}
  prepareRoute(outlet: RouterOutlet): any {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
  }

  ngOnInit(): void {
    this.currentTimezone = moment.tz.guess();       
    console.log(this.router.url)
    if(window.location.pathname !== "/admin-console"){
      this.service.getCreaticsHomepageLoggedIn().subscribe(data => {

        this.dbTimezone = data.timezone

        if(data.userId){
          if(this.currentTimezone !== this.dbTimezone){
            
            this.service.updateTimezone(this.currentTimezone).subscribe(res =>{

                console.log("timezone updated: ",this.currentTimezone);
            },
          (err => {
              console.log("Timezone updating failed with error: ",err)
          }))
          
          }
        }

        if (data.hasNotification) {

          const dialogRef = this.dialog.open(this.dialogTemplate, {
            disableClose: true,
            data: {
                title: data.notification.title,
                description: data.notification.description,
                link: data.notification.link
            }
          });

          dialogRef.afterClosed().subscribe(result => {

          });

        }

      })
    }


  }
}
